import { define } from 'wicked-elements'

define('[data-component~="search-ui"]', {
  init () {
    this.$search = this.element.querySelector('input[name="search"]')
    this.$selects = [...this.element.querySelectorAll('select')]
    this.handleSelectChange = this.handleSelectChange.bind(this)
  },
  connected () {
    this.$selects.forEach($select => $select.addEventListener('change', this.handleSelectChange))
    this.$search.addEventListener('search', this.handleSelectChange)
  },
  disconnected () {
    this.$selects.forEach($select => $select.removeEventListener('change', this.handleSelectChange))
    this.$search.removeEventListener('search', this.handleSelectChange)
  },
  handleSelectChange () {
    this.handleSubmit()
  },
  onSubmit (e) {
    e.preventDefault()
    this.handleSubmit()
  },
  handleSubmit () {
    const search = !!this.$search.value
      ? { search: this.$search.value }
      : {}
    const filters = this.$selects.filter($select => $select.selectedIndex).reduce((a, b) => {
      a[b.name] = b.value
      return a
    }, {})
    const parameters = Object.assign(filters, search)
    
    // Build Kirby param path
    const path = Object.keys(parameters).reduce((a, b) => {
      a.push(`${b}:${parameters[b]}`)
      return a
    }, []).join('/')
    
    // Update url
    window.location = `/${window.location.pathname.split('/')[1]}${path ? `/${path}` : ''}`
  }
})